/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для страницы истории заказов.
   */
  app.OrderListView = app.View.extend({
    el: '#current-orders-content, #archive-orders-content',
    events: {
      'click .js-download-order': 'onClickDownloadOrder',
    },
    additionalOptions: ['faderView', 'bodyView'],
    /**
     * @inheritDoc
     */
    run: function () {
      this.orderItem = this.$('.b-orders');

      _.each(this.orderItem, function (item) {
        var order = new app.Order({
          id: $(item).data('id'),
          is_service: $(item).data('is-service'),
          is_jp_request: Boolean($(item).data('is-jp-request')),
        });
        order.expand = 'expand=items';

        new app.OrderItemView({
          el: item,
          model: order,
          faderView: this.faderView,
          bodyView: this.bodyView,
        });
      }.bind(this));
      this.childViews.paginationView = new app.BasePaginationView();
    },

    /**
     * Отправляет необходимое событие в око.
     * @param event - событие клика
     */
    onClickDownloadOrder: function (event) {
      var targetLink = event.currentTarget;
      if (targetLink && targetLink.dataset && targetLink.dataset.downloadName) {
        app.helpers.OkoHelper.push({
          'n': 'custom',
          'category': 'download_order',
          'custom_str': ['click', targetLink.dataset.downloadName]
        });
      }
    }
  });
})();

}.call(window));